import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { connectModal, show as modalShow } from 'redux-modal';
import { Field, reduxForm, isPristine } from 'redux-form';
import Button from 'react-bootstrap-button-loader';
import get from 'lodash/get';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AdvertiserApi } from '../../../api';
import { setLoader, removeLoader } from '../../../actions';
import {
  InputField,
  required
} from '../../form';


class JobsForm extends Component {
  onFormSubmit(values) {
    const { dispatch, account, job, handleHide, formAction } = this.props;
    const args = formAction === 'Update' ? { account_id: account.uuid, id: job.id } : [values];
    dispatch(setLoader('JobForm'));
      
    dispatch(AdvertiserApi.actions.jobUpdate.patch(args, values, (error, success) => {
      dispatch(removeLoader('JobForm'));
      if (success) {
        dispatch(removeLoader('JobUpdate'));
        dispatch(AdvertiserApi.actions.jobs.get({ account_id: account.uuid }));
      } 
      handleHide();
    }));
  }

  render() {
    const { handleSubmit, isLoading, handleHide, formAction, show, heading } = this.props;
    
    return (
      <Modal show={show} onHide={handleHide}>
        <Modal.Header>
          <Modal.Title>{heading}</Modal.Title>
        </Modal.Header>
        <form onSubmit={handleSubmit(this.onFormSubmit.bind(this))}>
          <Modal.Body>
            <Field
              type='text'
              name='title'
              label='Title'
              component={InputField}
              validate={[required]}
              value={[]}
            /> 
            <Field
              type='text'
              name='category'
              label='Category'
              disabled
              component={InputField}
              validate={[required]}
              value={[]}
            />
            <Field
              type='text'
              textarea
              name='description'
              placeholder='Job Description'
              label='Description'
              component={InputField}
              validate={[required]}
              value={[]}
            />
            <Field
              type='url'
              name='url'
              placeholder='URL'
              label='URL'
              component={InputField}
              validate={[required]}
              value={[]}
            />
            <Field
              type='text'
              name='company'
              placeholder='company'
              label='Company'
              component={InputField}
              validate={[required]}
              value={[]}
            />
            <span style={{ textAlign: 'center', color: 'gray', marginTop: '15px' }}>
              <div className='alert alert-warning'>
                <FontAwesomeIcon icon="info-circle" /> Changes you make here will not update the ads already created from this job
              </div>
            </span>
          
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleHide}>Close</Button>
            <Button
              type='submit'
              loading={isLoading}
              bsStyle='primary'
            >
              {formAction || 'Submit'}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

const ResourceForm = reduxForm({
  form: 'JobForm'
});

const ResourceModal = connectModal({
  name: 'JobFormModal'
});

const mapStateToProps = (state) => {
  const { loader } = state;
  const isLoading = loader.includes('JobForm');
  const job = get(state.modal, 'JobFormModal.props.job', {});
  const account = get(state.modal, 'JobFormModal.props.account');

  const initialValues = {
    title: job.title, description: job.description, url: job.url, company: job.company, category: job.category
  };

  return { account, job, isLoading, initialValues };
};

export default connect(mapStateToProps)(ResourceModal(ResourceForm(JobsForm)));
